<template>
  <base-icon
    v-on="$listeners"
    v-bind="$attrs"
    :transform-function="(value) => typeof value === 'object' ? value.checked : value"
    :icon="(value) => value ? 'mdi-shield-check' : 'mdi-shield-alert'"
    :title="(value) => value ? 'settlement.titleIsChecked' : 'settlement.titleIsNotChecked'"
  />
</template>

<script>
import BaseIcon from '@/components/icons/BaseIcon';
export default {
  name: 'SettlementCheckedIcon',
  components: {BaseIcon},
}
</script>

<style scoped>

</style>